module.exports = __webpack_public_path__ + "static/img/checkbox-rounded-checked@2x.c3281c2.png";